import { useQuery } from "@apollo/client";

import { GET_COMPATIBLE_VERSIONS } from "./gql";

export const useTemplateVersions = (templateId: string, currentVersionId: string) => {
  const { data: versionsData, loading: versionsLoading } = useQuery(GET_COMPATIBLE_VERSIONS, {
    variables: {
      id: templateId,
      versionId: currentVersionId,
    },
  });

  return { data: versionsData, loading: versionsLoading };
};
